const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;

function isGaEnabled() {
  return Boolean(measurementId && measurementId !== 'G-XXXXXXX');
}

/** Loads gtag.js once when a valid measurement ID is set (build-time env). */
export function initGoogleAnalytics() {
  if (!isGaEnabled()) return;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', measurementId);

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);
}

export function trackReportClick() {
  if (!isGaEnabled() || typeof window.gtag !== 'function') return;
  window.gtag('event', 'get_report_click', {
    event_category: 'engagement',
    event_label: 'Get Report Button',
  });
}

export function trackLeadFormSubmit() {
  if (!isGaEnabled() || typeof window.gtag !== 'function') return;
  window.gtag('event', 'form_submit', {
    event_category: 'conversion',
    event_label: 'Lead Form',
  });
}

export function trackSchoolFormSubmit() {
  if (!isGaEnabled() || typeof window.gtag !== 'function') return;
  window.gtag('event', 'form_submit', {
    event_category: 'conversion',
    event_label: 'School Form',
  });
}

/** Anonymous /try pressure demo funnel */
export function trackTryDemoStart() {
  if (!isGaEnabled() || typeof window.gtag !== 'function') return;
  window.gtag('event', 'try_demo_start', { event_category: 'try_demo', event_label: 'start' });
}

export function trackTryDemoStep(step, choiceBit) {
  if (!isGaEnabled() || typeof window.gtag !== 'function') return;
  window.gtag('event', 'try_demo_step', {
    event_category: 'try_demo',
    event_label: `step_${step}`,
    value: choiceBit,
  });
}

export function trackTryDemoComplete() {
  if (!isGaEnabled() || typeof window.gtag !== 'function') return;
  window.gtag('event', 'try_demo_complete', { event_category: 'try_demo', event_label: 'reveal_done' });
}

export function trackTryDemoCta() {
  if (!isGaEnabled() || typeof window.gtag !== 'function') return;
  window.gtag('event', 'try_demo_cta', { event_category: 'try_demo', event_label: 'full_report' });
}

export function trackTryDemoReplay() {
  if (!isGaEnabled() || typeof window.gtag !== 'function') return;
  window.gtag('event', 'try_demo_replay', { event_category: 'try_demo', event_label: 'replay' });
}

/** Clicks from landing surfaces into /try (hero card, band, floating nudge) */
export function trackTryDiscoveryClick(surface) {
  if (!isGaEnabled() || typeof window.gtag !== 'function') return;
  window.gtag('event', 'try_discovery_click', {
    event_category: 'try_demo',
    event_label: surface,
  });
}

/** Fires scroll_75 once when the user scrolls past ~75% of the page. */
export function subscribeScrollDepth75() {
  if (!isGaEnabled()) return () => {};

  let fired = false;
  const onScroll = () => {
    if (fired) return;
    const doc = document.documentElement;
    const scrollHeight = doc.scrollHeight - window.innerHeight;
    if (scrollHeight <= 0) return;
    const scrollPercent = (window.scrollY / scrollHeight) * 100;
    if (scrollPercent > 75) {
      fired = true;
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'scroll_75', { event_category: 'engagement' });
      }
      window.removeEventListener('scroll', onScroll, { passive: true });
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  return () => window.removeEventListener('scroll', onScroll, { passive: true });
}
